"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = __importDefault(require("./Field"));
var Select_1 = __importDefault(require("../../Select"));
var Option_1 = __importDefault(require("../../Select/Option"));
var utils_1 = require("../utils");
var Context_1 = require("../Context");
var useStringValueValidation_1 = __importDefault(require("./hooks/useStringValueValidation"));
function SelectField(props, ref) {
    var 
    /* field props start*/
    label = props.label, name = props.name, required = props.required, validate = props.validate, disableLabelBox = props.disableLabelBox, fieldBasis = props.fieldBasis, bottomContent = props.bottomContent, 
    /* field props end */
    /* local props start */
    options = props.options, onChange = props.onChange, 
    /* local props end */
    selectProps = __rest(props, ["label", "name", "required", "validate", "disableLabelBox", "fieldBasis", "bottomContent", "options", "onChange"]);
    var fieldProps = {
        label: label,
        name: name,
        required: required,
        validate: validate,
        disableLabelBox: disableLabelBox,
        fieldBasis: fieldBasis,
        bottomContent: bottomContent
    };
    (0, useStringValueValidation_1.default)(name);
    var formContext = (0, Context_1.useFormContext)();
    var formId = formContext.formId, values = formContext.values, isSubmitting = formContext.isSubmitting, handleFormikChange = formContext.handleChange, handleBlur = formContext.handleBlur, errors = formContext.errors, touched = formContext.touched;
    var handleChange = function (event) {
        handleFormikChange(event);
        // custom onChange
        onChange === null || onChange === void 0 ? void 0 : onChange(event, formContext);
    };
    var hasError = errors[name] && touched[name] ? 'error' : undefined;
    return (react_1.default.createElement(Field_1.default, __assign({}, fieldProps),
        react_1.default.createElement(Select_1.default, __assign({}, selectProps, { className: hasError, variant: 'v2', 
            // formik validation won't trigger until an item is selected
            // disable native required for select
            required: false, id: (0, utils_1.getIdName)(formId, name), ref: ref, name: name, value: values[name], onChange: handleChange, onBlur: handleBlur, disabled: isSubmitting || selectProps.disabled }), options === null || options === void 0 ? void 0 : options.map(function (o) { return (react_1.default.createElement(Option_1.default, { key: o.value, value: o.value, disabled: o.disabled }, o.text)); }))));
}
exports.default = react_1.default.forwardRef(SelectField);
